import { Injectable } from '@angular/core';
import { ApiConfigService } from "../../shared-services/api-config.service";
import { tap } from "rxjs/operators";
import { BehaviorSubject, Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ScreensService {

    sites: BehaviorSubject<any>;

    constructor(private apiConfigService: ApiConfigService) {
        this.sites = new BehaviorSubject([]);
    }

    getSites(onlyRemote?): Observable<any> {
        return this.apiConfigService.get('api/site/all')
            .pipe(
                tap((values) => {
                    if (!onlyRemote) {
                        this.sites.next(values);
                    }
                })
            )
    }

    getMonuments(siteId): Observable<any> {
        return this.apiConfigService.get('api/site/' + siteId + '/monuments');
    }

    getHotspots(siteId): Observable<any> {
        const objectId = {cid: siteId};
        return this.apiConfigService.get('api/hotspot/panorama-images', objectId);
    }

    getAllPanoramaImages(): Observable<any> {
        return this.apiConfigService.get('api/hotspot/panorama-images-all');
    }

    getAllMonuments(): Observable<any> {
        return this.apiConfigService.get('api/monument/all');
    }
}
